import axios from 'axios'
import { config } from './config'
import {store} from "@/store";

const apiUrl = config.$api_url

export default {
    withdrawals(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/withdrawals', data)
            .then(response => response.data)
    },
    withdraw(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/withdraw-detail', data)
            .then(response => response.data)
    },
    checkWithdrawNumber(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/withdraw-check-number', data)
            .then(response => response.data)
    },
    checkBalance() {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/withdraw-check-balance')
            .then(response => response.data)
    },
    deposits(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/deposits', data)
            .then(response => response.data)
    },
    depositDetail(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/deposit-detail', data)
            .then(response => response.data)
    },
    depositsStatistics(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/deposits-statistics', data)
            .then(response => response.data)
    },
    getSites(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/deposits-sites', data)
            .then(response => response.data)
    },
    getAdministrators(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/deposits-administrators', data)
            .then(response => response.data)
    },
    approveDeposit(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/approve-deposit', data)
            .then(response => response.data)
    },
    apiResponseDetail(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/deposit-api-response-detail', data)
            .then(response => response.data)
    },
    cancelDeposit(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/cancel-deposit', data)
            .then(response => response.data)
    },
    siteStatistics(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/deposits-site-statistics', data)
            .then(response => response.data)
    },
    withdrawalsCount(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/withdrawals-count', data)
            .then(response => response.data)
    },
    approveWithdraw(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/approve-withdraw', data)
            .then(response => response.data)
    },
    viewWithdraw(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/view-withdraw', data)
            .then(response => response.data)
    },
    viewCancelWithdraw(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/cancel-view-withdraw', data)
            .then(response => response.data)
    },
    declineWithdraw(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/decline-withdraw', data)
            .then(response => response.data)
    },
    withdrawSiteStatistics(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/withdrawals-site-statistics', data)
            .then(response => response.data)
    },
    approveWithdrawManual(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/approve-withdraw-manual', data)
            .then(response => response.data)
    },
    panelTwoCheck(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/panel-two', data)
            .then(response => response.data)
    },
    panelTwoEdit(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/edit-panel-two', data)
            .then(response => response.data)
    },
    report(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/report', data)
            .then(response => response.data)
    },
    tcSorgu(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/tc-sorgu', data)
            .then(response => response.data)
    },
    bankAccounts(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/deposits/bank-accounts', data)
            .then(response => response.data)
    },
    withdrawManual(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/withdraw-manual', data)
            .then(response => response.data)
    },
}